module.exports = __webpack_public_path__ + "img/konvert-red.0a240df0.svg";